<button
  [type]="type"
  class="botao-redesign"
  [disabled]="disabled"
  [style.width]="'var(--botao-largura-override, ' + largura + ')'"
  [style.height]="altura"
  [style.backgroundColor]="corFundo"
  [style.color]="corTexto"
  [style.border]="corBorda ? larguraBorda + ' solid ' + corBorda : 'none'"
  [style.--botao-peso-label]="pesoLabel"
  (click)="clicar()"
>
  @if (icone) {
    <img [src]="icone" alt="" class="botao-redesign-icone" />
  }
  <span class="botao-redesign-label">{{ label }}</span>
</button>
